import React from "react";
import Layout from "../../components/layout";

const Generateinvoice = () => {
  return <>Generateinvoice</>;
};

export default Generateinvoice;
